<template>
	<div
		class="fixed z-50 inset-0 overflow-y-auto"
		aria-labelledby="modal-title"
		role="dialog"
		aria-modal="true"
		v-if="showModal"
	>
		<div
			class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 w-screen"
		>
			<transition name="fade">
				<div
					class="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity"
					:class="{
						'backdrop-blur-sm': blur,
					}"
					aria-hidden="true"
					v-if="showModal"
					ref="overlay"
					v-on:click="close()"
				></div>
			</transition>

			<!-- This element is to trick the browser into centering the modal contents. -->
			<span
				class="hidden sm:inline-block sm:align-middle sm:h-screen"
				aria-hidden="true"
				>&#8203;</span
			>

			<!-- Here comes the true content -->
			<transition name="zoomin">
				<div
					class="inline-block align-top bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-[7.5%] sm:align-top"
					:class="{
						'w-72 sm:max-w-lg sm:w-full': modalSize === 'sm',
						'sm:max-w-lg sm:w-full md:max-w-screen-md': modalSize === 'md',
						'sm:max-w-lg sm:w-full md:max-w-screen-lg': modalSize === 'lg'
					}"
				>
					<!-- main content -->
					<slot name="modal-content">
						<ui-wizard v-if="wizard" :steps="steps" :dataUrl="dataUrl" />

						<!-- Normal- UND Fehlermodal laufen über den ViewResolver (ui-modal-content).
						     :key erzwingt einen Remount, wenn sich der View wechselt (z.B. Formular →
						     Fehlermodal), damit ModalContent in created() neu auflöst. -->
						<ui-modal-content
							v-else
							:key="view.view"
							:view="view.view"
							:dataUrl="view.dataUrl"
							:data="view.data"
						/>
					</slot>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		defaultSize: {
			required: false,
			type: String,
			default: "md",
		},
	},
	data() {
		return {
			showModal: false,
			view: {},

			wizard: false, // todo in config wrappen?
			steps: null,

			blur: false,
			closeable: true,

			customSize: null, // todo in config wrappen?
		};
	},
	computed: {
		modalSize() {
			return this.customSize ?? this.defaultSize;
		},
	},
	mounted() {
		this.$bus.$off("modal:close");
		this.$bus.$on("modal:open", this.open);
	},
	beforeDestroy() {
		this.$bus.$off("modal:open", this.open);
		this.$bus.$off("modal:close", this.close);
		document.removeEventListener("keyup", this.closeWithEsc);
	},
	methods: {
		open(event) {
			if (event.size) {
				this.customSize = event.size;
			}

			if (event.blur) {
				this.blur = event.blur;
			}

			if (event.closeable === false) {
				this.closeable = event.closeable;
			}

			if (event.cta) {
				this.cta = event.cta;
			}

			if (event.view) {
				this.view = event.view;
			}

			if (event.steps) {
				this.wizard = true;
				this.steps = event.steps;
				this.dataUrl = event.dataUrl;
			}

			this.$bus.$off("modal:open");
			this.$bus.$off("modal:close", this.close);
			this.$bus.$on("modal:close", this.close);
			document.addEventListener("keyup", this.closeWithEsc);
			this.$bus.$on("modal:error", this.onError);

			this.showModal = true;
		},
		/**
		 * Fehler-Handler: löst statt des Formular-Views das Fehlermodal auf. cta erlaubt ein
		 * statuscode-spezifisches Ersatz-Modal (z.B. 402 → PremiumRequired), sonst das generische
		 * views/Modal/Error. Beide werden — wie der Normalfall — über den ViewResolver aufgelöst;
		 * die Fehlerdaten kommen als data.error an views/Modal/Error (Prop `error`).
		 *
		 * @param {Object} error Axios-Error (mit .response)
		 * @return {void}
		 */
		onError(error) {
			this.$bus.$off("modal:open");
			this.$bus.$off("modal:close", this.close);
			this.$bus.$on("modal:close", this.close);
			document.addEventListener("keyup", this.closeWithEsc);

			const statusCode = error?.response?.status ?? 500;

			let message = "Unbekanter Fehler ist aufgetreten.";
			if (error?.response?.data?.message) {
				message = error.response.data.message;
			} else if (error?.response?.statusText) {
				message = error.response.statusText;
			}

			const view =
				statusCode === this.cta?.code ? this.cta.view : "views/Modal/Error";

			this.view = { view, data: { error: { status: statusCode, message } } };

			this.showModal = true;
			this.$bus.$off("modal:error", this.onError);
		},
		closeWithEsc(event) {
			if (event?.keyCode == 27) {
				this.close();
			}
		},
		close() {

			if(! this.closeable){
				return;
			}

			this.$bus.$off("modal:close");
			this.$bus.$off("modal:open", this.open);
			this.$bus.$on("modal:open", this.open);
			document.removeEventListener("keyup", this.closeWithEsc);

			// resets
			this.showModal = false;
			this.customSize = null; // todo alternativ durch this.defaultSize überschreiben
			this.view = {};
			this.steps = null;
			this.wizard = false;
			this.blur = false;
			this.closeable = true;
		},
	},
};
</script>
